/**
 * Module dependencies.
 */

import { DescriptionWrapper } from '../products/products.style';
import { JSX } from 'react';
import { StyledDescription, StyledTitle } from './portfolio-introduction.style';
import { useTranslation } from 'next-i18next';

/**
 * Export `PortfolioIntroduction` component.
 */

export function PortfolioIntroduction(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <>
      <StyledTitle center>
        {translate('portfolio.introduction.title')}
      </StyledTitle>

      <DescriptionWrapper>
        <StyledDescription>
          {translate('portfolio.introduction.description')}
        </StyledDescription>
      </DescriptionWrapper>
    </>
  );
}
